import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "more-container"
};
const _hoisted_2 = {
  class: "el-dropdown-link"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "right-container"
};
const _hoisted_5 = {
  class: "content-container"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "description"
};
const _hoisted_8 = {
  class: "btn-container"
};
import { ref } from 'vue';
import { More } from '@element-plus/icons-vue';
import Icon from '@/components/Icon/src/Icon.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'RoleList',
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    roleList: {
      type: Array,
      required: true
    },
    showMore: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['onDelete', 'onEdit', 'onUse', 'onPage'],
  setup(__props, {
    emit: __emit
  }) {
    const tabsRef = ref(); // tabs ref
    // 定义属性
    const props = __props;
    // 定义钩子
    const emits = __emit;
    /** 操作：编辑、删除 */
    const handleMoreClick = async data => {
      const type = data[0];
      const role = data[1];
      if (type === 'delete') {
        emits('onDelete', role);
      } else {
        emits('onEdit', role);
      }
    };
    /** 选中 */
    const handleUseClick = role => {
      emits('onUse', role);
    };
    /** 滚动 */
    const handleTabsScroll = async () => {
      if (tabsRef.value) {
        const {
          scrollTop,
          scrollHeight,
          clientHeight
        } = tabsRef.value;
        if (scrollTop + clientHeight >= scrollHeight - 20 && !props.loading) {
          await emits('onPage');
        }
      }
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createElementBlock("div", {
        class: "card-list",
        ref_key: "tabsRef",
        ref: tabsRef,
        onScroll: handleTabsScroll
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.roleList, role => {
        return _openBlock(), _createElementBlock("div", {
          class: "card-item",
          key: role.id
        }, [_createVNode(_component_el_card, {
          class: "card",
          "body-class": "card-body"
        }, {
          default: _withCtx(() => [__props.showMore ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dropdown, {
            onCommand: handleMoreClick
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                command: ['edit', role]
              }, {
                default: _withCtx(() => [_createVNode(Icon, {
                  icon: "ep:edit",
                  color: "#787878"
                }), _cache[0] || (_cache[0] = _createTextVNode("编辑 "))]),
                _: 2
              }, 1032, ["command"]), _createVNode(_component_el_dropdown_item, {
                command: ['delete', role],
                style: {
                  "color": "red"
                }
              }, {
                default: _withCtx(() => [_createVNode(Icon, {
                  icon: "ep:delete",
                  color: "red"
                }), _cache[1] || (_cache[1] = _createTextVNode("删除 "))]),
                _: 2
              }, 1032, ["command"])]),
              _: 2
            }, 1024)]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
              type: "text"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(More))]),
                _: 1
              })]),
              _: 1
            })])]),
            _: 2
          }, 1024)])) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("img", {
            class: "avatar",
            src: role.avatar
          }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(role.name), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(role.description), 1)]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: $event => handleUseClick(role)
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("使用")])),
            _: 2
          }, 1032, ["onClick"])])])]),
          _: 2
        }, 1024)]);
      }), 128))], 544);
    };
  }
});